export function formatExpiry(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleString('pl-PL', { dateStyle: 'long', timeStyle: 'short' })
}

export function isPast(iso: string): boolean {
  return new Date(iso).getTime() <= Date.now()
}

/**
 * Hasło tymczasowe nauczyciela: tylko superadmin i aktywne konto, które ma już
 * ustawione hasło (`has_password`). Samo zaproszenie nie dowodzi aktywacji.
 */
export function canSetTeacherTemporaryPassword(
  isSuperadmin: boolean,
  status: string,
  hasPassword: boolean,
): boolean {
  return isSuperadmin && status === 'active' && hasPassword
}
